import { memo, useContext, useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { useQuery } from "react-query";
import { askQuestion } from "../../../core";
import { Typing } from "../../atoms";
import { BotContext } from "../../context/BotContext";
import { AnswerBubble } from "./history";

const ButtonAnswer = memo((props) => {
  const { buttonProps, setButtonProps, selectedRoom, inputRef } = useContext(
    BotContext
  );
  const [loading, setLoading] = useState(true);
  const [text] = useState(buttonProps?.question);
  const [label] = useState(buttonProps?.label_question);
  const [result, setResult] = useState("");

  useQuery(
    "askQuestion",
    async () => {
      const { data } = await askQuestion(text, label, selectedRoom?.name);
      setResult({ ...data.data, status: data.status, message: data.message });
      return data;
    },
    {
      // enabled:isBotMode,
      onSuccess() {
        props?.handleNewAnswer();
        setLoading(false);
        !isMobile && inputRef.current.focus();
      },
      onError(error) {
        console.log(error);
      },
      refetchOnMount: true,
    }
  );

  useEffect(() => {
    props.triggerNextStep();
    return () => {
      setButtonProps(undefined);
    };
  }, []);

  return (
    <div>
      {loading ? (
        <Typing />
      ) : (
        <AnswerBubble
          message={{ ...result, question_date: result.createdAt }}
          chat_agent={result?.chat_agent ? result.chat_agent : "BOT"}
        ></AnswerBubble>
      )}
    </div>
  );
});
export { ButtonAnswer };
